import { Toast as BaseUIToast } from '@base-ui/react/toast';
import { use } from 'react';

import { LocalizationContext } from '@hrworks/localization';

import { AlertBody, AlertDescription, AlertIcon, AlertTitle } from '../../Alert';
import { Icon } from '../../Icon';
import { IconButton } from '../../IconButton';
import { S } from './ToastItem.styles';
import type { ToastItemProps } from './ToastItem.types';

export const ToastItem = ({ toast }: ToastItemProps) => {
  const { translate } = use(LocalizationContext);
  const { data, title, description } = toast;

  return (
    <BaseUIToast.Root toast={toast} aria-hidden={false} render={<S.Root className={S.cls.Root} color={data?.color} />}>
      <AlertBody>
        {data?.icon && <AlertIcon>{data.icon}</AlertIcon>}
        <S.Content className={S.cls.Content}>
          {title && <BaseUIToast.Title render={<AlertTitle />}>{title}</BaseUIToast.Title>}
          {description && (
            <BaseUIToast.Description render={<AlertDescription />}>{description}</BaseUIToast.Description>
          )}
        </S.Content>
      </AlertBody>
      <S.CloseWrapper className={S.cls.CloseWrapper}>
        <BaseUIToast.Close
          aria-hidden={false}
          render={<IconButton corner="rounded" variant="unstyled" aria-label={translate('alert-close')} />}
        >
          <Icon name="alert-close" />
        </BaseUIToast.Close>
      </S.CloseWrapper>
    </BaseUIToast.Root>
  );
};
